import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ArrowCornerTopLeftThick = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		{...props}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path d="M18 24H16C13.7944 24 12 22.2056 12 20V6.8285L16.5851 11.4136C16.9471 11.7759 17.4474 12.0001 18 12.0001C19.1045 12.0001 20 11.1047 20 10.0001C20 9.4475 19.7759 8.94725 19.4135 8.58525L11.4149 0.5865C11.0529 0.22425 10.5526 0 10 0C9.44737 0 8.94712 0.224125 8.58512 0.5865L0.5865 8.58512C0.22425 8.94712 0 9.44737 0 10C0 11.1046 0.8955 12 2 12C2.55263 12 3.05288 11.7759 3.41488 11.4135L8 6.82837V19.9999C8 24.4111 11.5887 27.9999 16 27.9999H18C19.1046 27.9999 20 27.1045 20 25.9999C20 24.8952 19.1046 23.9999 18 23.9999V24Z" />
	</svg>
);

export default ArrowCornerTopLeftThick;
